"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const withMoveReviewModal_1 = __importDefault(require("../../../HOC/withMoveReviewModal"));
const styles_modules_less_1 = __importDefault(require("../styles.modules.less"));
const withPublicLinkModal_1 = __importDefault(require("../../../HOC/withPublicLinkModal"));
const constants_1 = require("../../../../reviews-modal/slice/sliceReview/constants");
const sliceReview_1 = require("../../../../reviews-modal/slice/sliceReview");
const ReviewSettingModal = (props) => {
    const { reviewRound, setOpenReviewModal } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const handleOpenReviewSetting = () => {
        if (setOpenReviewModal) {
            setOpenReviewModal(true);
        }
        dispatch((0, sliceReview_1.openModal)({
            status: constants_1.MODE.update,
            round: {
                ...reviewRound,
                id: (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.id) || (reviewRound === null || reviewRound === void 0 ? void 0 : reviewRound.roundId),
            },
        }));
    };
    return (react_1.default.createElement("div", { className: styles_modules_less_1.default['review-setting-btn'], onClick: handleOpenReviewSetting },
        react_1.default.createElement("i", { className: "fal fa-gear" }),
        " ",
        react_1.default.createElement("span", null, "Review Setting")));
};
exports.default = (0, withMoveReviewModal_1.default)((0, withPublicLinkModal_1.default)(ReviewSettingModal));
